export class User {
  email?: string | null;
  password?: string | null;
  phone?: string;
  firstConnection = false; // Used to manage TCU.
}
